<template>
  <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.13345e-06 4.85735C3.13345e-06 8.4708 -0.0430134 11.396 9.95131 14.9664C8.02988 12.8836 7.75027 10.0983 7.75027 7.20896L7.72517 0H0.0215117L3.13345e-06 4.85735Z"
      fill="#FC33FF"
    ></path>
    <path
      class="max-xl:fill-[#FC33FF]"
      d="M33.9298 48.0215H26.2261V30.743C26.2261 27.8393 25.925 25.0683 23.9928 22.9855C33.9872 26.556 33.9226 29.4811 33.9226 33.0982L33.9334 48.0215H33.9298ZM47.9928 41.0814C47.9928 37.468 48.0359 34.5428 38.0415 30.9688C39.963 33.0516 40.2748 35.8369 40.2748 38.7262V48.0072H48L47.9892 41.0778L47.9928 41.0814ZM19.8919 25.079C19.8919 21.4656 19.9349 18.5404 9.94055 14.9664C11.862 17.0492 12.1631 19.8345 12.1631 22.7239V48.0072H19.8883V25.0755L19.8919 25.079Z"
      fill="url(#paint0_linear_1927_3410)"
    ></path>
    <path
      class="max-xl:fill-[#FC33FF]"
      d="M33.9298 48.0215H26.2261V30.743C26.2261 27.8393 25.925 25.0683 23.9928 22.9855C33.9872 26.556 33.9226 29.4811 33.9226 33.0982L33.9334 48.0215H33.9298ZM47.9928 41.0814C47.9928 37.468 48.0359 34.5428 38.0415 30.9688C39.963 33.0516 40.2748 35.8369 40.2748 38.7262V48.0072H48L47.9892 41.0778L47.9928 41.0814ZM19.8919 25.079C19.8919 21.4656 19.9349 18.5404 9.94055 14.9664C11.862 17.0492 12.1631 19.8345 12.1631 22.7239V48.0072H19.8883V25.0755L19.8919 25.079Z"
      fill="url(#paint1_linear_1927_3410)"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_1927_3410"
        x1="12.6614"
        y1="15.9128"
        x2="38.5864"
        y2="56.159"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FC34FF"></stop>
        <stop offset="0.08" stop-color="#F434FF"></stop>
        <stop offset="0.2" stop-color="#E134FF"></stop>
        <stop offset="0.34" stop-color="#C134FF"></stop>
        <stop offset="0.43" stop-color="#A834FF"></stop>
        <stop offset="0.51" stop-color="#9434FF"></stop>
        <stop offset="0.59" stop-color="#7B34FF"></stop>
        <stop offset="0.7" stop-color="#5434FF"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_1927_3410"
        x1="16.4505"
        y1="45.2326"
        x2="44.4296"
        y2="14.5147"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.4" stop-color="#4BA5FF" stop-opacity="0"></stop>
        <stop offset="0.43" stop-color="#4BA5FF" stop-opacity="0.03"></stop>
        <stop offset="0.47" stop-color="#4BA5FF" stop-opacity="0.1"></stop>
        <stop offset="0.51" stop-color="#4BA5FF" stop-opacity="0.23"></stop>
        <stop offset="0.57" stop-color="#4BA5FF" stop-opacity="0.4"></stop>
        <stop offset="0.62" stop-color="#4BA5FF" stop-opacity="0.63"></stop>
        <stop offset="0.69" stop-color="#4BA5FF" stop-opacity="0.9"></stop>
        <stop offset="0.71" stop-color="#4BA5FF"></stop>
      </linearGradient>
    </defs>
  </svg>
</template>
<script setup lang="ts"></script>
